import { useEffect } from "react";
import { SiteHeader } from "@/components/site/SiteHeader";
import { SiteFooter } from "@/components/site/SiteFooter";
import { ValuationPanel } from "@/components/site/ValuationPanel";
import { HowItWorks, GoodToKnow, Faqs, Contact } from "@/components/site/HomeSections";
import { CheckCircle2, Car, Handshake } from "lucide-react";

const TRUST = [
  [CheckCircle2, "Free, no-obligation valuation"],
  [Car, "Sell directly to an established dealership"],
  [Handshake, "Straightforward, personal service"],
];
import { useSite, useJourney } from "@/lib/site";

export default function Home() {
  const { cfg, reload } = useSite();
  const j = useJourney();
  useEffect(() => {
    if (j.state.submitted) j.reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    reload();
    const q = new URLSearchParams(window.location.search);
    const src = q.get("utm_source") || q.get("src") || q.get("ref");
    if (src) sessionStorage.setItem("hcs_src", src.slice(0, 100));
    if (["px", "part_exchange"].includes(q.get("intent"))) sessionStorage.setItem("hcs_intent", "part_exchange");
  }, [reload]);
  const live = cfg.valuation.available;
  return (
    <div className="min-h-screen">
      <SiteHeader />
      <main>
        <section className="border-b border-border bg-white">
        <div className="mx-auto grid max-w-6xl gap-5 px-4 py-5 sm:px-6 md:grid-cols-[1fr_440px] md:gap-14 md:py-16" data-testid="hero-section">
          <div className="md:pt-8">
            <h1 className="text-[1.75rem] font-bold leading-[1.15] text-slate-900 sm:text-4xl lg:text-[2.75rem]" data-testid="hero-heading">
              What's your car worth?
            </h1>
            <p className="mt-2.5 text-base text-slate-700 md:mt-5 md:text-lg" data-testid="hero-supporting-text">
              {live ? "Get an instant estimate for your car in seconds." : "Enter your registration and mileage and we'll review your car."}
            </p>
            <ul className="mt-5 space-y-3 md:mt-8 md:space-y-3.5" data-testid="hero-trust-points">
              {TRUST.map(([Icon, t]) => (
                <li key={t} className="flex items-center gap-3 text-base font-medium text-brand-navy">
                  <Icon className="h-5 w-5 shrink-0 text-[#934047]" strokeWidth={1.75} aria-hidden />{t}
                </li>
              ))}
            </ul>
          </div>
          <div id="valuation" className="scroll-mt-24 min-w-0 rounded-md border border-border bg-[#FAF9F6] p-4 sm:p-7" data-testid="valuation-panel">
            <ValuationPanel />
          </div>
        </div>
        </section>
        <HowItWorks />
        <div className="mx-auto max-w-6xl px-4 sm:px-6">
          <GoodToKnow />
          <Faqs />
          <Contact />
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
